import ConfigManager from '@/config/ConfigManager.js'
import BzbsApi from '@/core/Http/BzbsApi.js';
import { map } from 'rxjs/operators';

export default {
    getAccountType: function (username) {
        let url = ConfigManager.getApiModuleUrl() + '/user/passowrdtype';
        let params = {
            username: username,
        };
        return BzbsApi.connectBzbsGet(url, null, params).pipe(map((res) => {
            let passwordType = res.data.data.BzbsPasswordType;
            let info = {
                passwordType: passwordType,
            };
            return info;
        }));
    },
}
